import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, NgZone} from '@angular/core';
import {InfluencerNote} from '../../../../models/influencer-note';
import {AuthService} from '../../../core/auth.service';
import {TranslateService} from '@ngx-translate/core';
import { CommonConstant } from '../../../app.constants';

@Component({
  selector: 'inline-edit-note',
  templateUrl: './inline-edit-note.component.html',
  styleUrls: ['./inline-edit-note.component.scss']
})
export class InlineEditNoteComponent implements OnInit {
  @ViewChild('contextBox')
  public contextBox: ElementRef;
  @ViewChild('noteContainer') noteContainer: ElementRef;
  @Input()
  public note: InfluencerNote;
  @Input()
  public isSampleNote = false;
  @Output()
  public addNoteSucessCallback: EventEmitter<any> = new EventEmitter();
  @Output()
  public deleteNoteSucessCallback: EventEmitter<any> = new EventEmitter();
  @Output()
  public blurCallback: EventEmitter<any> = new EventEmitter();
  @Output()
  public deletingNoteCallback: EventEmitter<number> = new EventEmitter();

  public readonly = true;
  public noteHeight = CommonConstant.DEFAULT_NOTE_HEIGHT;
  private lastChangeContent: string;
  private canEditable = false;
  constructor(private authService: AuthService,
              private translate: TranslateService) { }

  ngOnInit() {
    this.readonly = this.isSampleNote || (this.note && this.note.id > 0);
  }

  onKeyDown(e) {
    if (e.keyCode === 13 && (e.metaKey || e.ctrlKey)) {
      this.createOrUpdateNote();
      e.preventDefault();
    }
  }

  onKeyUp(e) {
    const textArea = this.noteContainer.nativeElement.querySelector('.influencer-note');
    if (textArea) {
      textArea.style.height = CommonConstant.DEFAULT_NOTE_BOX_STYLE_HEIGHT;
      textArea.style.height = textArea.scrollHeight + 'px';
    }
  }

  createOrUpdateNote(isCreated = true) {
    const currentUser = this.authService.getUser();
    if (!currentUser) {
      this.authService.logout();
      return;
    }
    this.note.userId = Number(currentUser.data.id);
    this.addNoteSucessCallback.emit({
      note: this.note,
      isCreated: isCreated
    });
    this.readonly = true;
  }

  editNote() {
    if (!this.canEditNote) {
      return;
    }
    if (this.noteContainer) {
      const contentBox = this.noteContainer.nativeElement.querySelector('.content-inner');
      if (contentBox) {
        this.noteHeight = contentBox.scrollHeight;
      }
    }
    this.readonly = false;
    this.lastChangeContent = this.note.content;
    setTimeout(() => {
      this.contextBox.nativeElement.focus();
    }, 200);
  }

  onBlur(evt) {
    if (document.contains(evt.target) && !this.readonly && this.note.content === '') {
      this.readonly = true;
      this.note.content = this.lastChangeContent;
      this.lastChangeContent = null;
      if (this.blurCallback) {
        this.blurCallback.emit();
      }
    }
    if (this.lastChangeContent && this.lastChangeContent !== this.note.content) {
      this.createOrUpdateNote(false);
    }
  }

  onMouseenter() {
    const currentUser = this.authService.getUser();
    if (!currentUser || !currentUser.data) {
      this.canEditable = false;
      return;
    }
    this.canEditable = this.note.userId === Number(currentUser.data.id);
  }

  onMouseleave() {
    this.canEditable = false;
  }

  deleteNote(noteId) {
    this.deletingNoteCallback.emit(noteId);
  }

  get canEditNote() {
    return this.readonly && this.canEditable;
  }

  get lastModificationDate() {
    if (!this.note) {
      return null;
    }
    return this.note.modifiedAt ? this.note.modifiedAt : this.note.createdAt;
  }

  get userName() {
    if (!this.note || (this.note && this.note.userId === 0)) {
      return '';
    }
    if (this.note.userId !== 0 && !this.note.userName) {
      return this.translate.instant('note.deleted_user');
    }
    return this.note.userName;
  }

  get canSaveNote() {
    return this.note && this.note.content && this.note.content.trim() !== '';
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/inline-edit-note/inline-edit-note.component.ts